import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

const DOC_CATS = [
  "Proposta", "Contrato", "Planejamento", "Plano de Mídia",
  "Boleto", "Nota Fiscal", "Boleto Fornecedor", "NF Fornecedor",
  "Peça Entregue", "Reunião de Atendimento", "Cotação de Mídia",
  "Cotação de Mídia Aprovada", "Orçamento de Produção", "Orçamento Aprovado",
];

export default function ClientDocumentsEditor() {
  return (
    <GenericAdminCRUD
      title="Repositório de Documentos"
      subtitle="Organizado por Cliente → Produto → Campanha. Categorias: Proposta, Contrato, Planejamento, Plano de Mídia, Boletos, NFs, etc."
      path="client-documents"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "product_id", label: "Produto", type: "productSelect" },
        { key: "campaign_id", label: "Campanha", type: "campaignSelect" },
        { key: "category", label: "Categoria *", type: "select", options: DOC_CATS },
        { key: "department", label: "Departamento", type: "select", options: ["Atendimento", "Planejamento/Estratégia", "Criação", "Mídia", "Tráfego Pago", "Produção"] },
        { key: "title", label: "Título *", type: "text" },
        { key: "url", label: "URL do arquivo (link ou /api/media/{id})", type: "text", span: 2 },
        { key: "note", label: "Observações", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "title", label: "Documento" },
        { key: "category", label: "Categoria" },
        { key: "campaign_id", label: "Campanha", render: (it, { campaigns }) => campaigns.find((c) => c.id === it.campaign_id)?.name || "—" },
        { key: "product_id", label: "Produto", render: (it, { products }) => products.find((p) => p.id === it.product_id)?.name || "—" },
      ]}
    />
  );
}
